import React from 'react';

const NotFound = () => <div>Not Found page</div>;

export default NotFound;
